export { default } from "./AdminContentSettingsCardFooter";
